import { render, staticRenderFns } from "./FinishForReal.vue?vue&type=template&id=4b8f425c&"
import script from "./FinishForReal.vue?vue&type=script&lang=js&"
export * from "./FinishForReal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports